import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {
    type UpdateDefaultSorting$Request,
    updateDefaultSorting,
} from 'src/openapi/admin/apis/SearchTemplateApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useUpdateDefaultSorting = ({onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((request: UpdateDefaultSorting$Request) => apiDispatch(
        updateDefaultSorting(request),
    ), [apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
